import { useState } from 'react'
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps'

interface MarkerWithInfowindowProps {
  lat: number
  lng: number
  title: string
  infoWindow?: JSX.Element
  customPin?: JSX.Element
}

export const MarkerWithInfowindow = (props: MarkerWithInfowindowProps): JSX.Element => {
  const [infowindowOpen, setInfowindowOpen] = useState(false)
  const [markerRef, marker] = useAdvancedMarkerRef()

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        onClick={() => setInfowindowOpen(true)}
        position={props}
        title={props.title}
        clickable
      >
        {props.customPin}
      </AdvancedMarker>
      {infowindowOpen && props.infoWindow != null && (
        <InfoWindow
          anchor={marker}
          maxWidth={200}
          onCloseClick={() => setInfowindowOpen(false)}
        >
          {props.infoWindow}
        </InfoWindow>
      )}
    </>
  )
}
